import { DateDisplayFormats, DateService } from '@application/time/date.service';
import { Flex, Icon, Spacer, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import dayjs from 'dayjs';
import React, { ReactNode } from 'react';

interface Props {
	dateService: DateService;
	peerReadTimestamp: string;
	peerReadFullName: string;
}

function formatDateTime(textDate: string, dateService: DateService) {
	const date = dayjs(textDate);
	const today = dayjs();

	// Check if the date is today
	if (date.isSame(today, 'day')) {
		return date.format(dateService.getLocaleSpecificDateFormatTemplate(DateDisplayFormats.JUST_TIME));
	} else {
		return date.format(dateService.getLocaleSpecificDateFormatTemplate(DateDisplayFormats.FULL_DISPLAY_IN_CURRENT_YEAR_NO_WEEKDAY));
	}
}

function ReceiptText({ children }: { children: ReactNode }) {
	return (
		<Text
			variant={'labelXSmallRegular'}
			style={{
				color: tokens.color.content.muted,
			}}
		>
			{children}
		</Text>
	);
}

export function ReadReceiptClientComponent({ peerReadTimestamp, peerReadFullName, dateService }: Props) {
	const seenDate = formatDateTime(peerReadTimestamp, dateService);

	return (
		<Spacer vertical={tokens.spacing.x1}>
			<Flex direction={'row'} align={'center'} gap={tokens.spacing.x0_25}>
				<Icon type={'check'} size={'xSmall'} color={tokens.color.success.content} />
				<ReceiptText>{peerReadFullName}</ReceiptText>
				<ReceiptText>{seenDate}</ReceiptText>
			</Flex>
		</Spacer>
	);
}
